<template>
  <div class="pa-5" style="padding-left: 2%; padding-right: 2%; background-color: #F8F9FA;">
    <h2>Dashboard</h2>
    <v-row style="margin: 0 -8px;">
      <v-col cols="12" sm="12" md="3" lg="3">
        <v-autocomplete
          v-model="selectGroupCompanyName"
          :items="groupCompanyNames"
          item-text="nameEN"
          item-value="_id"
          outlined
          dense
          placeholder="เลือกเครือ"
          label="เครือ"
          class="mt-2"
          background-color="#ffffff"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3">
        <v-autocomplete
          v-model="selectCompanyName"
          :items="companyNames"
          item-text="name"
          item-value="id"
          outlined
          dense
          placeholder="เลือกบริษัท"
          label="บริษัท"
          class="mt-2"
          background-color="#ffffff"
          :disabled="selectGroupCompanyName === ''"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3">
        <v-autocomplete
          v-model="selectOrgchart"
          :items="orgchartNames"
          item-text="orgChartName"
          item-value="_id"
          outlined
          dense
          placeholder="เลือกสายบังคับบัญชา"
          label="สายบังคับบัญชา"
          class="mt-2"
          background-color="#ffffff"
          @change="initDashboard()"
          :disabled="selectCompanyName === ''"
        >
        </v-autocomplete>
      </v-col>
      <v-spacer />
      <v-col cols="12" sm="12" md="3" lg="3">
        <v-select
          v-model="selectYear"
          :items="['2025', '2024', '2023', '2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015', '2014', '2013', '2012', '2011', '2010']"
          outlined
          dense
          placeholder="ปี"
          label="เลือกปี"
          class="mt-2"
          background-color="#ffffff"
          @change="initDashboard()"
        >
        </v-select>
      </v-col>
    </v-row>

    <OverlayLoading :loading="loadingData" />

    <v-row v-if="!loadingData" class="justify-space-between">
      <v-col cols="12" sm="12" md="5" lg="5" class="">
        <div class="elevation-1 dashboard-box-showdata pa-5 justify-space-around">
          <span class="dashboard-company-title">เครือและบริษัท</span>
          <v-row>
            <v-col cols="" class="text-center">
              <v-col cols="12" class="mx-0">
                <v-icon class="mt-5" size="32" color="#3776E9"
                :style="`border: 0px solid currentColor;
                  background-color: ${'#EFF4FD' };
                  border-radius:50%; height: 70px; width: 70px;`"
                >mdi-apache-kafka</v-icon>
              </v-col>
              <v-col cols="12" class="mt-0 pt-0 mx-0" v-if="selectGroupCompanyNameEn === 'ทั้งหมด'">
                <span style="font-weight: 500; font-size: 14px; color: #757575;">จำนวนเครือ {{selectGroupCompanyNameEn}}</span><br>
                <span style="font-weight: 500; font-size: 24px; color: #3776E9;">{{countGroupCompany}}</span>
              </v-col>
              <v-col cols="12" class="mt-0 pt-0 mx-0" v-else>
                <span style="font-weight: 500; font-size: 14px; color: #757575;">เครือ {{selectGroupCompanyNameEn}}</span><br>
              </v-col>
            </v-col>
            <v-col cols="1" class="text-center">
              <v-divider
                vertical
              ></v-divider>
            </v-col>
            <v-col cols="" class="text-center">
              <v-col cols="12" class="mx-0">
                <v-icon class="mt-5" size="32" color="#3776E9" v-if="selectCompanyNameEn === 'ทั้งหมด' || companyNames.length === 1"
                :style="`border: 0px solid currentColor;
                  background-color: ${'#EFF4FD' };
                  border-radius:50%; height: 70px; width: 70px;`"
                >mdi-city</v-icon>
                <!-- <v-avatar
                  v-else
                  size="64"
                  rounded
                  class="mt-5"
                >
                  <v-img
                    :lazy-src="require('@/assets/icons/no_user.png')"
                    :src="require('@/assets/icons/no_user.png')"
                    :style="`border: 0px solid currentColor;
                  background-color: ${'#EFF4FD' };
                  border-radius:50%; height: 64px; width: 64px;`"
                  />
                </v-avatar> -->
                <v-avatar
                v-else
                class="mt-5 elevation-1"
                  size="70"
                >
                  <v-img
                    contain
                    :lazy-src="require('@/assets/icons/company-logo3.png')"
                    :src="failed_image ? require('@/assets/icons/company-logo3.png') : companyImage"
                    v-on:error="onImgError()"
                    aspect-ratio="2.7"
                  />
                </v-avatar>
              </v-col>
              <v-col cols="12" class="mt-0 pt-0 mx-0" v-if="selectCompanyNameEn === 'ทั้งหมด' || companyNames.length === 1">
                <span style="font-weight: 500; font-size: 14px; color: #757575;">จำนวนบริษัท</span><br>
                <span class="mx-4" style="font-weight: 500; font-size: 24px; color: #3776E9;">{{countCompany}}</span>
              </v-col>
              <v-col cols="12" class="mt-0 pt-0 mx-0" v-else>
                <span style="font-weight: 500; font-size: 14px; color: #757575;">บริษัท {{selectCompanyNameEn}}</span><br>
              </v-col>
            </v-col>
          </v-row>
        </div>
      </v-col>

      <v-col cols="12" sm="12" md="7" lg="7" class="">
        <div class="elevation-1 dashboard-box-showdata pa-3">
          <span class="dashboard-company-title">สถิติจำนวนพนักงานเข้าใหม่ - ลาออก</span>
          <!-- <v-row style="max-height: 20px;">
            <v-col cols="5">
              <span class="dashboard-company-title">สถิติจำนวนพนักงานเข้าใหม่ - ลาออก</span>
            </v-col>
            <v-col cols="3">
              <div style="max-height: 10px;">
                <v-select
                  :items="['2021','2020']"
                  outlined
                  dense
                  :height="5"
                  placeholder="ปี"
                >
                </v-select>
              </div>
            </v-col>
          </v-row> -->
          <!-- <span class="dashboard-gender-label">อายุเฉลี่ย {{averageAgeEmployees}} ปี</span> -->
          <div class="pa-0">
            <v-row align="center" justify="end">
              <div v-for="(item, i) in chartStat" :key="`linework-${i}`">
                <div class="d-flex flex-row align-center mt-5 mr-3">
                  <v-icon dark :color="item.color" class="mr-3">mdi-checkbox-blank</v-icon>
                  <div class="flex-row text-wrap" style="word-break: break-all !important;">
                    <span class="dashboard-eachgender-number mr-2" style="font-size: 0.8rem;">{{item.title}}</span>
                    <!-- <span class="dashboard-eachgender-number mr-1" style="font-size: 1rem;">{{item.count}}</span> -->
                    <!-- <span class="dashboard-eachgender-label mr-1" style="font-size: 1rem;">คน</span> -->
                  </div>
                </div>
            </div>
            </v-row>
            <bar-chart ref="chartemployee" :data="chartDataEmp" :options="employeeOptions" style="height: 200px;"></bar-chart>
          </div>
        </div>
      </v-col>

      <v-col cols="12" sm="12" md="7" lg="7" class="">
        <div class="elevation-1 dashboard-box-showdata-structure pa-5">
          <span class="dashboard-company-title">โครงสร้างงาน</span>
          <v-row class="mt-5 mb-3 align-center" :class="!$vuetify.breakpoint.mobile?'px-1':''">
              <!-- class="border-black-v4 mx-1" -->
            <v-col cols=""
              v-for="item in cards"
              :key="item.title"
              :class="$vuetify.breakpoint.name === 'xl' ? 'border-black-v4 mx-5' : 'border-black-v4 mx-2'"
              >
              <!-- <v-card
                :color="active ? '#EFF4FD' : 'white'"
                :class="`pa-0 ${!active? 'border-black-v4':''}`"
                outlined
                style="border: 1px solid #EEEEEE; box-sizing: border-box; border-radius: 4px;"
                height="110"
                width="110"
                @click="toggle"
              > -->
              <v-row class="">
                <v-col cols="12" class="text-center">
                  <span>{{item.title}}</span><br/>
                  <v-btn :color="item.color" x-large class="mt-3 pa-1">
                    <span class="title-count-structure">{{item.count}}</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
        <div class="elevation-1 dashboard-box-showdata-employee pa-5 mt-5">
          <span class="dashboard-company-title">ข้อมูลพนักงาน</span>
          <v-row class="mt-0 mb-8" justify=center v-if="chartLineWorkEmployeesV2[0].count === 0 && chartLineWorkEmployeesV2[1].count === 0">
            <v-col cols="8" class="text-center">
              <img width="150" height="110" src="@/assets/icons/emp-data-icon2.png">
            </v-col>
            <v-col cols="8" class="text-center" style="margin-top: -1%;">
              <span class="" style="font-weight: bold;">ยังไม่มีข้อมูลหรือจำนวนพนักงาน</span>
            </v-col>
          </v-row>
          <v-row class="mt-0 mb-0 align-center" :class="!$vuetify.breakpoint.mobile?'px-3':''" v-else>
            <link rel="stylesheet" href="https://github.com/chartjs/Chart.js/releases/download/v2.9.3/Chart.min.css">
            <v-col cols="12" sm="12" md="4" lg="4">
              <pie-chart ref="chartlinework" :data="chartLineWorkDataV2" :options="chartLineWorkOptions" style="height: 8rem !important;"></pie-chart>
              <div class="donut-inner" :style="$vuetify.breakpoint.name === 'lg' ? 'margin-top: -36%;' : $vuetify.breakpoint.name === 'md' ? 'margin-top: -42%;' : 'margin-top: -31%;'">
                <span style="font-weight: 500; font-size: 20px;">{{chartLineWorkEmployeesV2[0].count + chartLineWorkEmployeesV2[1].count}}</span>
                <p style="color: #757575;">คน</p>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="8" style="height: fit-content !important;">
              <div v-for="(item, i) in chartLineWorkEmployeesV2" :key="`linework-${i}`">
                <div class="d-flex flex-row align-center mt-5">
                  <v-icon dark :color="item.color" class="mr-3">mdi-checkbox-blank</v-icon>
                  <div class="flex-row text-wrap" style="word-break: break-all !important;">
                    <span class="dashboard-eachgender-number mr-2" style="font-size: 1rem;">{{item.title}}</span>
                    <span class="dashboard-eachgender-number mr-1" style="font-size: 1rem;">{{item.count}}</span>
                    <span class="dashboard-eachgender-label mr-1" style="font-size: 1rem;">คน</span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>

      <v-col cols="12" sm="12" md="5" lg="5" class="">
        <!-- <div class="elevation-1 dashboard-box-showdata-table pa-1 justify-space-around"> -->
        <div class="elevation-1 dashboard-box-showdata-table pa-3 justify-space-around">
          <span class="dashboard-company-title">ตำแหน่งงาน
            <v-chip
              v-show="countAllPosition !== 0"
              class="ml-2"
              color="#EFF4FD"
              text-color="#0370B7"
              small
            >
              <span>{{countAllPosition}}</span>
            </v-chip>
          </span>
          <v-row v-if="countAllPosition !== 0" class="mt-5">
            <v-col cols="12" style="height: 50vh; overflow: auto;">
                <!-- hide-default-footer -->
              <v-data-table
                :headers="headers"
                :items="dataPosition"
                :items-per-page="200"
                class="elevation-0"
                hide-default-footer
                disable-sort
              >
              <template v-slot:[`item.no`]="{ item }">
                {{ dataPosition.indexOf(item)+1 }}
              </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row justify=center style="height: 50vh; overflow: auto;" v-else>
            <v-col cols="8" class="text-center mt-18" style="margin-top: 25%;">
              <img width="150" height="110" src="@/assets/icons/emp-data-icon2.png">
            </v-col>
            <v-col cols="8" class="text-center" :style="$vuetify.breakpoint.name === 'xl' ? 'margin-top: -20%;' : 'margin-top: -35%;'">
              <span class="" style="font-weight: bold;">ยังไม่มีข้อมูลตำแหน่งงาน</span>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import { EventBus } from '@/EventBus'
import {
  // hostUrl,
  hostImageUrlv3,
  getListGroupCompanyName,
  getListCompanyByGroupCompanyEngName,
  fetchDashboardByCompanyId
} from '@/API/API'
import OverlayLoading from '../_template/OverlayLoading.vue'
import BarChart from './BarChart.vue'
// import swal from 'sweetalert'
import PieChart from './PieChart.vue'
import { EventBus } from '@/EventBus'

export default {
  name: 'dashboard-filter-overall',
  components: {
    OverlayLoading, PieChart, BarChart
  },
  data: vm => ({
    companyImage: '',
    imageCheck: '',
    loadingData: true,
    groupCompanyNames: [],
    companyNames: [],
    orgchartNames: [],
    selectGroupCompanyName: '',
    selectCompanyName: '',
    selectYear: new Date().getFullYear().toString(),
    selectOrgchart: '',
    countGroupCompany: 1,
    countCompany: 1,
    countAllPosition: 1,
    // date: new Date().toISOString().substr(0, 7),
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu: false,
    amountEmployees: 0,
    amountEmployeesFemale: 0,
    amountEmployeesMale: 0,
    amountEmployeesLineWork: 0,
    averageAgeEmployees: 0,
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      borderWidth: '10px',
      hoverBackgroundColor: 'red',
      hoverBorderWidth: '10px',
      legend: {
        labels: false
      },
      tooltips: {
        bodyFontFamily: 'Sarabun',
        bodyFontSize: 16,
        bodyFontStyle: 'bold'
      }
    },
    // chartData: {
    //   hoverBackgroundColor: 'red',
    //   hoverBorderWidth: 10,
    //   labels: ['เพศหญิง', 'เพศชาย'],
    //   datasets: [
    //     {
    //       label: 'Data One',
    //       backgroundColor: ['rgb(236, 86, 40)', 'rgb(77, 174, 181)'],
    //       data: [0, 0]
    //     }
    //   ]
    // },
    chartLineWorkOptions: {
      type: 'RoundedDoughnut',
      responsive: true,
      maintainAspectRatio: false,
      borderWidth: '10px',
      hoverBackgroundColor: 'red',
      hoverBorderWidth: '20px',
      cutoutPercentage: 70,
      legend: {
        labels: false
      },
      tooltips: {
        bodyFontFamily: 'Sarabun',
        bodyFontSize: 14,
        bodyFontStyle: 'bold'
      }
    },
    chartLineWorkData: {
      hoverBackgroundColor: 'red',
      hoverBorderWidth: 10,
      labels: [],
      datasets: [
        {
          label: 'Data One',
          backgroundColor: [],
          data: []
        }
      ]
    },
    chartLineWorkDataV2: {
      hoverBackgroundColor: 'red',
      hoverBorderWidth: 25,
      labels: [' พนักงานภายนอก', ' พนักงานภายใน'],
      // datasets: [
      //   {
      //     label: 'Data One',
      //     backgroundColor: ['#3776E9', '#2CBA88'],
      //     data: [0, 0],
      //     borderRadius: 60
      //   }
      // ]
      datasets: [
        {
          label: 'Data One',
          data: [0, 0],
          backgroundColor: ['#3776E9', '#2CBA88'],
          // borderColor: ['#3776E9', '#2CBA88'],
          borderWidth: 1,
          borderRaius: 60
        }]
    },
    chartLineWorkColor: ['rgb(103, 173, 91)', 'rgb(193, 57, 50)', 'rgb(33, 71, 135)', 'rgb(228, 175, 73)', 'rgb(236, 86, 40)', 'rgb(77, 174, 181)'],
    chartLineWorkEmployees: [],
    failed_image: false,
    imageUser: null,
    companyByRegion: [],
    hoverItemImg: '',
    headers: [
      {
        text: 'ลำดับ',
        align: 'start',
        sortable: false,
        value: 'no',
        width: '70px'
      },
      { text: 'ชื่อตำแหน่งงาน', value: 'positionName' },
      { text: 'จำนวนพนักงาน', value: 'countUser', width: '125px' }
    ],
    dataPosition: [
      {
        no: '1',
        position: 'ผู้อำนวยการ',
        countEmployee: 6
      },
      {
        no: '2',
        position: 'ผู้ช่วยผู้อำนวยการ',
        countEmployee: 10
      }
    ],
    cards: [
      { title: 'สายงาน', color: '#3D5D85', count: '90' },
      { title: 'ฝ่ายงาน', color: '#5CC2EF', count: '90' },
      { title: 'ส่วนงาน', color: '#6FB540', count: '90' },
      { title: 'หน่วยงาน', color: '#F2BE47', count: '90' },
      { title: 'กลุ่มงาน', color: '#F37959', count: '90' }
    ],
    chartStat: [
      { title: 'พนักงานเข้าใหม่', color: '#3776E9' },
      { title: 'พนักงานลาออก', color: '#C7C7C7' }
    ],
    chartLineWorkEmployeesV2: [
      { title: 'พนักงานภายนอก', color: '#3776E9', count: '500' },
      { title: 'พนักงานภายใน', color: '#2CBA88', count: '1200' }
    ],
    chartDataEmp: {
      type: 'bar',
      // labels: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน'],
      labels: ['ม.ค', 'ก.พ', 'มี.ค', 'เม.ย', 'พ.ค', 'มิ.ย', 'ก.ค', 'ส.ค', 'ก.ย', 'ต.ค', 'พ.ย', 'ธ.ค'],
      datasets: [{
        pointRadius: 4,
        label: 'พนักงานเข้าใหม่',
        borderWidth: 1,
        backgroundColor: '#3776E9',
        borderColor: [
          // 'rgba(255,99,132,1)',
          // 'rgba(54, 162, 235, 1)',
          // 'rgba(255, 206, 86, 1)',
          // 'rgba(255, 159, 64, 1)'
        ],
        pointBorderColor: '#2554FF',
        data: [2, 3, 5, 2]
      },
      {
        label: 'พนักงานลาออก',
        borderWidth: 1,
        backgroundColor: '#C7C7C7',
        borderColor: [],
        pointBorderColor: '#2554FF',
        data: [5, 3, 5, 2]
      }
      ]
    },
    employeeOptions: {
      scales: {
        yAxes: [{
          ticks: {
            min: 0,
            max: 10,
            // stepSize: 5,
            reverse: false,
            beginAtZero: true
          },
          gridLines: {
            display: true
          }
        }],
        xAxes: [{
          barPercentage: 0.6,
          gridLines: {
            display: false
          }
        }]
      },
      legend: {
        display: false
      },
      responsive: true,
      maintainAspectRatio: false,
      innerHeight: 20,
      bar: {
        dataLabels: {
          position: 'bottom'
        }
      },
      plugins: {
        datalabels: {
          color: 'pink',
          labels: {
            value: {},
            title: {
              color: 'blue'
            }
          }
        }
      }
    },
    approveRole: localStorage.approveRole,
    companyList: [],
    groupCompanyList: [],
    valueSelect: '',
    itemCompanyEn: []
  }),
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    const self = this
    self.tokenUser = self.$store.state.token
    self.getGroupCompany()
    if (self.$store.state.user.groupCompanyNameEng && self.$store.state.user.companyId) {
      // self.selectGroupCompanyName = self.$store.state.user.groupCompanyNameEng
      // self.selectGroupCompanyName = self.$store.state.user.groupCompanyId
      // self.selectCompanyName = self.$store.state.user.companyId || ''
      // self.getCompanyByGroup()
      // self.initDashboard()
      if (localStorage.approveRole === 'User') {
        self.selectGroupCompanyName = self.$store.state.user.groupCompanyId
        self.selectCompanyName = self.$store.state.user.companyId
      } else {
        self.selectGroupCompanyName = ''
        self.selectCompanyName = ''
        this.initDashboard()
      }
    }
    // console.log(self.$store.state)
  },
  beforeDestroy () {
    EventBus.$off('setApproveRole')
  },
  mounted () {
    EventBus.$on('setApproveRole', this.setApproveRole)
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    computedPercentageFemale () {
      if (this.amountEmployees) return this.roundToTwo(this.amountEmployeesFemale * 100 / this.amountEmployees)
      else return 0
    },
    computedPercentageMale () {
      if (this.amountEmployees) return this.roundToTwo(this.amountEmployeesMale * 100 / this.amountEmployees)
      else return 0
    },
    imgUser () {
      return this.failed_image ? require('@/assets/icons/no_user.png') : this.imageUser
    },
    imgMap (item, index) {
      return this.hoverItemImg
    },
    selectGroupCompanyNameEn () {
      const self = this
      self.groupCompanyList = []
      var selectGroupCompanyList = ''
      self.groupCompanyList = this.groupCompanyNames.filter(e => e._id === this.selectGroupCompanyName)
      // console.log('list', this.groupCompanyNames)
      // console.log('ID', this.selectGroupCompanyName)
      // console.log('list select', groupCompanyList)
      selectGroupCompanyList = self.groupCompanyList[0].nameEN
      return selectGroupCompanyList
    },
    selectCompanyNameEn () {
      const self = this
      var selectCompanyList = ''
      self.companyList = this.companyNames.filter(e => e.id === this.selectCompanyName)
      selectCompanyList = self.companyList[0].name
      return selectCompanyList
    }
  },
  watch: {
    selectGroupCompanyName () {
      if (this.selectGroupCompanyName) {
        this.selectCompanyName = ''
        this.getCompanyByGroup()
      } else {
        // this.selectCompanyName = ''
        this.getCompanyByGroup()
      }
    },
    date (val) {
      // console.log(val)
      this.dateFormatted = this.formatDate(this.date)
      // this.dateFormatted = this.formatDate(new Date(val).toISOString())
      // console.log(this.dateFormatted)
    },
    selectCompanyName () {
      if (this.selectCompanyName) {
        this.selectOrgchart = ''
        this.initDashboard()
      } else {
        this.initDashboard()
      }
    }
  },
  methods: {
    onImgError () {
      this.failed_image = true
    },
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
      this.selectCompanyName = ''
      this.initDashboard()
    },
    async getGroupCompany () {
      const self = this
      var temp = []
      var listTemp = []
      try {
        const res = await getListGroupCompanyName(this.tokenUser)
        if (res.success) {
          listTemp = res.result
          // listTemp.unshift({
          //   _id: '',
          //   nameEN: 'ทั้งหมด',
          //   nameTH: 'ทั้งหมด',
          //   listNameEng: 'ทั้งหมด'
          // })
          listTemp.map((el, i) => {
            temp.push({
              id: i,
              nameTH: el.listNameTh,
              nameEN: el.listNameEng,
              ...el
            })
          })
          this.groupCompanyNames = temp
          this.groupCompanyNames.unshift({
            _id: '',
            nameEN: 'ทั้งหมด',
            listNameEng: 'ทั้งหมด'
          })
          this.countGroupCompany = this.groupCompanyNames.length
          this.getCompanyByGroup()
        }
      } catch (error) {
        console.log(error)
      } finally {
        if (self.$refs.chartlinework) self.$refs.chartlinework.render()
        if (self.$refs.chartemployee) self.$refs.chartemployee.render()
      }
    },
    async getCompanyByGroup () {
      // this.loading = true
      // this.selectCompanyName = ''
      this.countGroupCompany = this.groupCompanyNames.length
      const self = this
      self.itemCompanyEn = this.groupCompanyNames.filter(e => e._id === this.selectGroupCompanyName)
      self.valueSelect = self.itemCompanyEn[0].listNameEng
      // this.companyNames = []
      const obj = {
        // groupCompanyList: [this.selectGroupCompanyName]
        groupCompanyList: self.valueSelect === 'ทั้งหมด' ? [] : [self.valueSelect]
        // groupCompanyList: ['INET']
      }
      var temp = []
      try {
        const res = await getListCompanyByGroupCompanyEngName(this.tokenUser, obj)
        console.log('🚀 ~ res company', res)
        if (res.success) {
          res.result.map((el, index) => {
            temp.push({
              no: index + 1,
              id: el._id,
              name: el.companyShortNameEng
            })
          })
          this.companyNames = temp
          this.companyNames.unshift({
            id: '',
            name: this.companyNames.length === 0 ? 'ไม่มี' : 'ทั้งหมด'
          })
          self.countCompany = this.companyNames.length - 1
          // this.companyImage = ''
          // this.selectCompanyName = ''
          this.initDashboard()
          this.loading = false
        }
      } catch (error) {
        console.log(error)
      }
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async initDashboard () {
      const self = this
      // self.selectOrgchart = ''
      self.loadingData = true
      const obj = {
        // companyId: self.selectCompanyName,
        companyId: this.selectCompanyName,
        role: this.approveRole,
        groupCompanyId: this.selectGroupCompanyName,
        orgChartHeader: this.selectOrgchart,
        datePick: this.selectYear
      }
      // var tempLineWorkName = []
      // var tempLineWorkEmployees = []
      // var tempLineWorkColors = []

      // self.imageUser = `${hostUrl}/${self.$store.state.user.userImg}`
      if (self.$store.state.user.userImg === '') {
        self.imageUser = `${hostImageUrlv3}/_/${self.$store.state.user.emailOneId}`
      } else {
        self.imageUser = `${hostImageUrlv3}/${self.$store.state.user.userImg}/${self.$store.state.user.emailOneId}`
      }
      // self.imageUser = `${hostImageUrlv3}/${self.$store.state.user.userImg}/${self.$store.state.user.emailOneId}`

      try {
        const res = await fetchDashboardByCompanyId(self.tokenUser, obj)
        console.log('initDashboard', res)
        if (res.success) {
          this.companyImage = `${this.api}/api/vMonk/companys/getcompanyFileById/` + res.companyData[0].companyImage
          this.failed_image = false
          self.orgchartNames = []
          const tempData = []
          self.orgchartNames = res.orgChartHeaderData
          self.orgchartNames.unshift({
            _id: '',
            orgChartName: self.orgchartNames.length === 0 ? 'ไม่มี' : 'ทั้งหมด'
          })
          // if (self.selectOrgchart === '') self.selectOrgchart = self.orgchartNames[0]._id
          self.countGroupCompany = res.groupCompanyCount
          // self.countCompany = res.companyCount
          self.dataPosition = res.allPosition
          self.countAllPosition = res.allPositionCount
          self.cards[0].count = res.numberOfLineOfwork || 0
          self.cards[1].count = res.numberOfDepartment || 0
          self.cards[2].count = res.numberOfSection || 0
          self.cards[3].count = res.numberOfAgency || 0
          self.cards[4].count = res.numberOfGroupWork || 0
          // console.log('card', this.cards)
          self.chartLineWorkEmployeesV2[0].count = res.numberOuter
          self.chartLineWorkEmployeesV2[1].count = res.numberInner
          tempData.push(res.numberOuter)
          tempData.push(res.numberInner)
          // console.log('tempdata', tempData)
          self.chartLineWorkDataV2.datasets[0].data = tempData
          // EventBus.$emit('barChartData', res.monthRegister, res.monthResign)
          // console.log('emit')
          self.chartDataEmp.datasets[0].data = res.monthRegister
          self.chartDataEmp.datasets[1].data = res.monthResign
        }
      } catch (error) {
        self.chartLineWorkEmployeesV2[0].count = 0
        self.chartLineWorkEmployeesV2[1].count = 0
        console.log(error)
        if (self.$refs.chartlinework) self.$refs.chartlinework.render()
        if (self.$refs.chartemployee) self.$refs.chartemployee.render()
      } finally {
        self.loadingData = false
        if (self.$refs.chartgender) self.$refs.chartgender.render()
        if (self.$refs.chartlinework) self.$refs.chartlinework.render()
        if (self.$refs.chartemployee) self.$refs.chartemployee.render()
      }
    },
    computedPercentageValue (value, total) {
      // console.log(value * 100 / this.amountEmployeesLineWork)
      // console.log(value * 100 / total)
      // console.log(value, total, this.amountEmployeesLineWork)
      if (total && total > this.amountEmployeesLineWork) return `${this.roundToTwo(value * 100 / total)}%`
      else return `${this.roundToTwo(value * 100 / this.amountEmployeesLineWork)}%`
    },
    // onImgError (event) {
    //   this.failed_image = true
    // },
    mousehovPlace (item, index) {
      if (item.value === 'northern') {
        this.hoverItemImg = 'cnx'
      } else if (item.value === 'northeastern') {
        this.hoverItemImg = 'kkc'
      } else if (item.value === 'central') {
        this.hoverItemImg = 'bkk'
      } else if (item.value === 'southern') {
        this.hoverItemImg = 'hy'
      } else {
        this.hoverItemImg = ''
      }
    },
    mouseleavePlace () {
      this.hoverItemImg = ''
    },
    roundToTwo (num) {
      return +(Math.round(num + 'e+2') + 'e-2')
    }
  }
}
</script>

<style scoped>
.dashboard-box-showdata {
  border: none;
  border-radius: 10px;
  background-color: #fff;
  display: flex;
  height: 105%;
  flex-direction: column;
}
.dashboard-box-showdata-v2 {
  border: none;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  height: 85%;
  flex-direction: column;
}
.dashboard-box-showdata-structure {
  border: none;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  height: 50%;
  flex-direction: column;
}
.dashboard-box-showdata-employee {
  border: none;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  height: 50%;
  flex-direction: column;
  margin-bottom: 6%;
}
.dashboard-box-showdata-table {
  border: none;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  height: 104%;
  widows: 20%;
  flex-direction: column;
  margin-bottom: 6%;
}
.dashboard-box-structure-mini {
  border: none;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  /* height: 15%; */
  /* flex-direction: column; */
}
.dashboard-company-title {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
  font-size: 14px;
  line-height: 22px;
  font-weight: bold;
  color: #1654C6;
}

.dashboard-allemployees-label {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
  font-size:1.25rem;
  font-weight: 700;
  color: #333;
}

.dashboard-allemployees-img {
  display: block;
  overflow: hidden;
  border-radius: 50%;
}

.dashboard-allemployees-img img {
  width: 100%;
  height: auto;
}

.dashboard-allemployees-amount {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
  font-size:1.5rem;
  font-weight: 700;
  color: rgb(67, 150, 75);
}

.dashboard-allemployees-unit {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
  font-size:1.25rem;
  font-weight: 600;
  color: #999;
}

.dashboard-gender-title {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
  font-size:1.25rem;
  font-weight: 700;
  color: #333;
}

.dashboard-gender-label {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
  font-size:1rem;
  font-weight: 600;
  color: #666;
}

.dashboard-gender-box {
  border: none;
  border-radius: 10px;
  box-shadow: 1px 1px 3px #999;
}

.dashboard-eachgender-title {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
  font-size:1.15rem;
  font-weight: 700;
  color: #333;
}

.dashboard-eachgender-label {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
  font-size:1.25rem;
  font-weight: 600;
  color: #666;
}

.dashboard-eachgender-number {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
  font-size:1.5rem;
  font-weight: 600;
  color: #333;
}
.title-count-structure {
  font-family: 'Sarabun', sans-serif !important;
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 48px;

  display: flex;
  align-items: center;
  text-align: center;

  color: #FFFFFF;
}
.v-progress-linear {
  border-radius: 25px !important;
  background: transparent;
  overflow: hidden;
  position: relative;
  transition: 0.2s cubic-bezier(0.4, 0, 0.6, 1);
  width: 100%;
}

.v-application {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
}

#doughnut-chart {
  /* font-family: 'Sarabun', sans-serif !important; */
  font-family: 'Sarabun', sans-serif !important;
}

.box-company-place {
  border-radius: 10px;
  border: 2px solid rgb(219, 219, 219);
}

.box-company-place:hover {
  box-shadow: 1px 1px 3px #999;
  cursor: pointer;
}

.dashboard-mapallcompany-img {
  display: block;
  overflow: hidden;
}

.dashboard-mapallcompany-img img {
  width: 100%;
  height: auto;
}

.hoverregion {
  -webkit-animation: pulsate-bck 0.5s ease-in-out both;
  animation: pulsate-bck 0.5s ease-in-out both;
}

@-webkit-keyframes pulsate-bck {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}
@keyframes pulsate-bck {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}
.icon-image {
    font-size: 32px;
    color: rgb(55, 118, 233);
    caret-color: rgb(55, 118, 233);
    border: 0px solid currentcolor;
    background-color: rgb(239, 244, 253);
    border-radius: 50%;
    height: 64px;
    width: 64px;
}
canvas {
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
}
.donut-inner {
    text-align: center;
    /* margin-top: -50%; */
    font-family: sans-serif;
}
/* .donut-inner .percent {
    font-size: 65px;
    margin-bottom: 3px;
    margin-top: 0;
    font-weight: bolder;
}
.donut-inner .percent small{
    font-size: 35px;
    font-weight: bolder;
    font-family: Arial;
}
.donut-inner .price {
    margin: 0;
    font-size: 30px;
} */

</style>
